import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error500: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>System Error</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Something went wrong! <br /> Please try again later.
      </div>

      <div className='text-center'>
        <Link to='/' className='btn btn-lg btn-primary fw-bolder'>
          Go to homepage
        </Link>
      </div>
    </>
  )
}

export {Error500}
